import INFTCollections from '../models/INFTCollections'

//default
import DefaultCard from '../nftFormats/Default/Card/DefaultCard'
import DefaultDetail from '../nftFormats/Default/Detail/DefaultlDetail'
import ActivityDetail from '../nftFormats/Default/Activity/ActivityDetail'

//seal
import CryptoSealCard from '../nftFormats/CryptoSeals/Card/CryptoSealCard'
import CryptoSealDetail from '../nftFormats/CryptoSeals/Detail/CryptoSealDetail'
import CryptoSealActivtyDetail from '../nftFormats/CryptoSeals/Activity/CryptoSealActivtyDetail'

//moose
import MooseCard from '../nftFormats/Moose/Card/MooseCard'
import MooseActivtyDetail from '../nftFormats/Moose/Activity/MooseActivtyDetail'
import MooseDetail from '../nftFormats/Moose/Detail/MooseDetail'

const CollectionList: INFTCollections[] = [
  {
    id: 'yetiswapCollection',
    tokenAddress: '0x9c39fB419556a472A12CE5835c8b4c28A7868257',
    name: 'YetiSwap Collection',
    cardFormat: DefaultCard,
    detailFormat: DefaultDetail,
    activityFormat: ActivityDetail,
    category: 0,
    creatorAddress: ''
  },
  {
    id: 'cryptoSeals',
    tokenAddress: '0xaD484EBe32e012E923d171893d0551ea81f20D29',
    name: 'Cryptoseals',
    cardFormat: CryptoSealCard,
    detailFormat: CryptoSealDetail,
    activityFormat: CryptoSealActivtyDetail,
    category: 2,
    creatorAddress: '0xaD484EBe32e012E923d171893d0551ea81f20D29'
  },
  {
    id: 'MooseNFTCollection',
    tokenAddress: '0xeD1e6469bb39d7Cf38cB12378899dbCf818D6061',
    name: 'Moose NFT Collection 1',
    cardFormat: MooseCard,
    detailFormat: MooseDetail,
    activityFormat: MooseActivtyDetail,
    category: 1,
    creatorAddress: '0xeD1e6469bb39d7Cf38cB12378899dbCf818D6061'
  },
]

export const CollectionObjectList: { [key: string]: number } = {
  [CollectionList[1].tokenAddress.toLowerCase()]: CollectionList[1].category,
  [CollectionList[2].tokenAddress.toLowerCase()]: CollectionList[2].category
}

export default CollectionList
